import { ErrorHandler, LOCALE_ID, NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { AppSelectionComponent } from './app-selection/app-selection.component';
import { AuthComponent } from './components/auth/auth.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { ClarityModule } from '@clr/angular';
import { ComingSoonRegistrationComponent } from './app-selection/coming-soon-registration.component';
import { ComingSoonReportComponent } from './app-selection/coming-soon-report.component';
import { GlobalErrorHandler } from 'src/app/error-handler/global-error-handler';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { HttpErrorInterceptor } from 'src/app/http-interceptor/http-interceptor';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { OAuthModule } from 'angular-oauth2-oidc';
import { SelectProfileComponent } from './components/select-profile/select-profile.component';
import { ServicesModule } from './services/services.module';
import { SharedModule } from './shared/shared.module';
import localeEnCA from '@angular/common/locales/en-CA';
import { registerLocaleData } from '@angular/common';
import { WelcomeComponent } from './app-selection/welcome.component';
import { MfaReskinComponent } from './login-reskin/mfa-reskin.component';
import { ResetPwdReskinComponent } from './login-reskin/reset-pwd-reskin.component';

registerLocaleData(localeEnCA);
@NgModule({
  declarations: [
    AppComponent,
    AuthComponent,
    SelectProfileComponent,
    AppSelectionComponent,
    ComingSoonReportComponent,
    ComingSoonRegistrationComponent,
    WelcomeComponent,
    MfaReskinComponent,
    ResetPwdReskinComponent
  ],
  imports: [
    ClarityModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    SharedModule,
    ServicesModule,
    OAuthModule.forRoot({
      resourceServer: {
        allowedUrls: ['http://localhost:4200'],
        sendAccessToken: true
      }
    }),
    NgIdleKeepaliveModule.forRoot()
  ],
  bootstrap: [AppComponent],
  providers: [
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true
    },
    { provide: LOCALE_ID, useValue: 'en-CA' }
  ]
})
export class AppModule { }
